import { Component, Input, OnInit, ViewChild, Host, Optional, Injector } from '@angular/core';
import { FormControl, AbstractControl } from '@angular/forms';
import { EasyFormComponent } from '../form/form.component';
import { FMSUtilityService } from '../../services/utility/utility.service';
import { FormGroupComponent } from '../form-group/form-group.component';
import { BaseInputComponent } from '../base-input/base-input.component';
import { SelectOption } from '../data-model';
import { LocalizePipe } from '../../../../pipes/Localize.pipe';

@Component({
    selector: 'selectInput',
    templateUrl: 'options-input.component.html',
    styleUrls: [
        '../base-input/base-input.component.css'
    ]
})
export class FormSelectComponent extends BaseInputComponent implements OnInit {

    get familyId() { return 'input'; }

    @Input() options: SelectOption[] = [];

    get requiredError() {
        return this.required && this.formControl && !this.formControl.pristine && ((this.formControl.errors && this.formControl.errors.required) || (this.formControl.value < 0));
    }

    constructor(@Host() parentForm: EasyFormComponent, @Optional() @Host() parentFormGroup: FormGroupComponent, protected injector: Injector) {
        super(parentForm, parentFormGroup, injector);
    }


    childOnInit() {

    }

}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/easyForms/components/options-input/options-input.component.ts